const RevenueSpendByAccountListTableLangKey = [
	'column_date',
	'column_account',
	'column_team',
	'column_kt_group',
	'column_revenue_cpa',
	'column_revenue_offer_spend',
	'column_revenue_total',
	'column_spend',
	'column_roi',
	'column_account_fb',
	'column_creo',
	'column_installs',
	'column_slices',
	'column_agency_percent',
	'column_profit'
] as const

type IRevenueSpendByAccountListTableLangKey = typeof RevenueSpendByAccountListTableLangKey[number]

export type IRevenueSpendByAccountListTableLang = {
	revenue_spend_by_account_list_table: Record<IRevenueSpendByAccountListTableLangKey, string>
}

const langEntries = RevenueSpendByAccountListTableLangKey.map(
	(key: IRevenueSpendByAccountListTableLangKey) => [key, `revenue_spend_by_account_list_table.${key}`]
)

const langObj: Record<IRevenueSpendByAccountListTableLangKey, string> = Object.fromEntries(langEntries)

export const REVENUE_SPEND_BY_ACCOUNT_LIST_TABLE_LANG_KEY: IRevenueSpendByAccountListTableLang = {
	revenue_spend_by_account_list_table: langObj
}
